/*eslint-disable */
import React, { Component } from "react";
import { Grid, Segment, Placeholder, Label, Pagination } from "semantic-ui-react";
import { Link } from "react-router-dom";
import GridPlaceholder from "./gridPlaceholder";
import RouteManager from "./routeManager";
import ReadAxios from "../../axiosComponent/read";
import MiniPlaceholder from "./miniPlaceHolder";
import VehicleType from "./vehicleType";
import ReadAxiosRequestAxios from '../../axiosComponent/allAxiosCommonRequest'
import OrdersHeader from '../../orderComponent/ordersHeaders';
import { translate } from "react-i18next";
import BLrender from "../../common/bl_no";
import moment from 'moment';
import 'moment-timezone';
import { faSleigh } from "@fortawesome/free-solid-svg-icons";
import LoadingPlaceholder from "../../placeholderComponent/loadingPlaceholder";
import { branch_Ids, vendor_Id } from "../../../utils/constant";
import cogoToast from "cogo-toast";

export class ReportingGridView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listItems: [],
      isFetching: false,
      page: 0,
      totalPages: 0,
      currentPage: 1,
      itemCount: 10,
      itemsPerPage: 10,
      setPageValue: 10,
      statusFilter: "",
      searchFilterGrouping: "",
      exportDataFromSearch: null,
      status: []
    };
  }

  async componentDidMount() {
    if (this.props?.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getInitalData(this.props.pageNoOn)
      })
    }
    else
      this.getInitalData(1)
  }

  componentDidUpdate(prevProps) {
    if (this.props?.pageNoOn != prevProps.pageNoOn) {
      this.setState({ currentPage: this.props.pageNoOn }, () => {
        this.getInitalData(this.props.pageNoOn)
      })
    }
  }

  getInitalData = (activePage) => {
    let booking_branch_ids = localStorage.getItem('branchIds')?.length > 0 ? localStorage.getItem('branchIds').toString()
      : ''
    this.setState({
      isFetching: true,
    })
    let vendorId = localStorage.getItem("vendorId")
    ReadAxios({ completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/vehicle/reporting/${vendorId}?${this.state.searchFilterGrouping}&booking_branch_ids=${booking_branch_ids}&page=${activePage}&limit=${this.state.itemsPerPage}${this.state.statusFilter}` })
      .then((res) => {
        this.setState(
          {
            isFetching: false,
            listItems: res.data.data || [],
            totalPages: res?.data?.meta?.totalPages || 0,
          },
        );
      })
      .catch((err) => {
        console.log('err', err);
        this.setState(
          {
            isFetching: false,
          }
        )
      });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage })
    this.props.updatePaginationPage(activePage)
    this.getInitalData(activePage);
  }

  handleStatusChange = (data) => {
    this.setState({ status: data.status })
    if (data.length !== 0) {
      let statusOrder = `&status=${data?.status ? data.status.join(',') : data ? data.join(',') : ''}`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updatePaginationPage(1)
        this.getInitalData(1);
      })
    } else {
      let statusOrder = `&status=`
      this.setState({ statusFilter: statusOrder }, () => {
        this.props.updatePaginationPage(1)
        this.getInitalData(1);
      })
    }
    //this.getInitalData(1);
  }

  // scroll listener function
  handleScroll = () => {
    let divInnerHeight = document.getElementsByClassName("style");
    let scrollLimit = 59;
    scrollLimit = scrollLimit + 675 * (this.state.page - 1);
    if (
      Math.ceil(
        divInnerHeight[0].scrollTop > scrollLimit || this.state.isFetching
      )
    ) {
      this.setState({ isFetching: true }, () => {
        this.incrementPage();
      });
    }
  };

  // new page increment
  incrementPage = () => {
    if (!this.state.isFetching) return;
    this.fetchMoreListItems();
  };

  fetchMoreListItems = () => {
    this.fetchData();
    this.setState({ isFetching: false }, () => this.incrementPage());
  };

  exporttrueDataGrid = () => {

    let payload = {
      bl_no: this.state?.exportDataFromSearch?.bl_no || "",
      vendor_id: this.state?.exportDataFromSearch?.vendor_id || "",
      vehicle_no: this.state?.exportDataFromSearch?.vehicle_no || "",
      order_reference_no: this.state?.exportDataFromSearch?.order_reference_no || "",
      common_order_number: this.state?.exportDataFromSearch?.common_order_number || "",
      delivery_reference_no: this.state?.exportDataFromSearch?.delivery_reference_no || "",
      required_on: this.state?.exportDataFromSearch?.required_on || "",
      end_required_on: this.state?.exportDataFromSearch?.end_required_on || "",
      invoice_no: this.state?.exportDataFromSearch?.invoice_no || "",
      status: this.state.status,
      transporter_lr_no: this.state?.exportDataFromSearch?.transporter_lr_no || "",
      route_id: this.state?.exportDataFromSearch?.route_id ? this.state.exportDataFromSearch.route_id : "",
      consignor_id: this.state?.exportDataFromSearch?.consignor_id ? this.state.exportDataFromSearch.consignor_id : "",
      consignee_id: this.state?.exportDataFromSearch?.consignee_id ? this.state.exportDataFromSearch.consignee_id : "",
      from_order_created_on : this.state?.exportDataFromSearch?.from_order_created_on ? this.state.exportDataFromSearch.from_order_created_on : "",
      to_order_created_on : this.state?.exportDataFromSearch?.to_order_created_on ? this.state.exportDataFromSearch.to_order_created_on : "",
      lr_no : this.state?.exportDataFromSearch?.lr_no ? this.state.exportDataFromSearch.lr_no : "",

    }

    const bookingBranchIds = branch_Ids.length > 0 ? JSON.stringify(branch_Ids.toString()) : "";
    const vendorId = vendor_Id

    ReadAxiosRequestAxios({
      url: `${process.env.REACT_APP_TA_API_URL}/orders/vehicle/reporting/${vendorId}/excel/export?bl_no=${payload.bl_no}&transporter_lr_no=${payload.transporter_lr_no}&vendor_name=${payload.vendor_id}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&booking_branch_ids=${bookingBranchIds}&status=${payload.status}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}&page=1&limit=10&`,
      method: "get",
      noQ: true
    })
      .then((res) => {
        cogoToast.success(res.data.message);
        if (res?.status == 200) {
          this.setState({ responseReceived: true })
        }
        this.setState({ spinnerLoading: false })
      })
      .catch((err) => {
        if (err?.response?.data?.message)
          cogoToast.error(err.response.data.message);
        else
          cogoToast.error(DEMAP_INVOICE_ERROR);
        this.setState({ spinnerLoading: false })
      });
  }

  handleMetaSearch = (payload) => {
    this.state.exportDataFromSearch = payload;
    let url = `bl_no=${payload.bl_no}&vendor_name=${payload.vendor_id}&vehicle_no=${payload.vehicle_no}&delivery_reference_no=${payload.delivery_reference_no}&start_required_on=${payload.required_on}&end_required_on=${payload.end_required_on}&order_reference_no=${payload.order_reference_no}&invoice_no=${payload.invoice_no}&common_order_number=${payload.common_order_number}&transporter_lr_no=${payload.transporter_lr_no}&route_id=${payload.route_id}&consignor_id=${payload.consignor_id}&consignee_id=${payload.consignee_id}&from_order_created_on=${payload.from_order_created_on}&to_order_created_on=${payload.to_order_created_on}&lr_no=${payload.lr_no}`

    this.setState({ searchFilterGrouping: url }, () => {
      console.log(url)
      this.props.updatePaginationPage(1)
      this.getInitalData(1)
    });


  };


  render() {
    const { t } = this.props;
    let timezone = localStorage.getItem("timezone");
    let content = ""

    return (
      <React.Fragment>
        <OrdersHeader
          hideTransporter={true}
          showStatusFilter={true}
          allotedOrdersStatusShow={this.props.allotedOrdersStatusShow}
          handleStatusChange={this.handleStatusChange}
          title={t("orders.vr_title") || "Vehicle Reporting"}
          LinkName="/add-shipment"
          handleSearch={this.handleChange}
          hideFilter={false}
          handleMetaSearch={this.handleMetaSearch}
          reportingStatusShow={true}
          // exportDataGrid={this.exportDataGrid}
          exporttrueDataGrid={this.exporttrueDataGrid}
          exportHidden={this.props.exportHidden}
          radioToggle={this.props.radioToggle}
          toggleView={this.props.toggleView}
          toggle={this.props.toggle}
          baseURL={this.props.baseURL}
          searchLoading={this.state.isFetching}
        />
        <div
          className="animated slideInDown m-2 style"
          style={{ width: "99%", height: "100%", paddingBottom: "90px" }}
        // onScroll={this.handleScroll}
        >
          {/* {console.log("LIST LENGTH :", this.state.listItems.data.length)} */}
          {this.state.listItems.length > 0 ? (
            this.state.listItems.map((item, index) => {
              content = <BLrender id={item.vendor_order_id} />
              return (
                <>
                  <Segment raised className="ml-3" key={index} size="mini">
                    <Link
                      target="_blank"
                      to={{
                        pathname: "/reporting-order-details",
                        state: { item, index },
                        search: `?shipmentId=${item.vendor_order_id}`,
                      }}
                    >
                      <Grid columns={1} className="m-1">
                        <Grid.Row textAlign="center">
                          <Grid.Column width={3} className="ml-3" style={{ marginTop: "-15px" }}>
                            <Grid columns="3">
                              <Grid.Row className="pb-0 pt-0">
                                <Grid.Column>
                                  <Label as="a" color='orange' ribbon>
                                    {localStorage.getItem('customerNumber') == 1166 ? "Booking No" : t("list_view.order_no") || "Order No"} : {item.order_reference_no}
                                  </Label>
                                  <label className="w3-text-gray mt-3 labelName text-nowrap">
                                    {item.shipment.movement_type == "Import" || item.shipment.movement_type == "Importar" ? t("list_view.estimated_on") : t("list_view.required_on")}
                                  </label>
                                  <label className="p-bold-600 text-nowrap">
                                    {moment.parseZone(item.shipment.required_on).format('DD-MM-YYYY HH:mm')}
                                  </label>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Grid.Column>
                          <Grid.Column width={5}>
                            <RouteManager budgeted_kms={item.budgeted_kms} routeId={item.shipment.route_id} movement_type={item.shipment.movement_type} />
                          </Grid.Column>
                          <Grid.Column width={2}>
                            <Grid.Row className="pb-0 pt-0">
                              <label className="w3-text-gray labelName text-nowrap">
                                {t("list_view.vehicle_number") || "Vehicle Number"}
                              </label>
                            </Grid.Row>
                            {item.driver_name ?
                              <Grid.Row className="pb-0 pt-0">
                                <label className="w3-text-gray labelName text-nowrap">
                                  {t("list_view.driver_name") || "Driver Name"}
                                </label>
                              </Grid.Row>
                              : ""}
                            {item.driver_number ?
                              <Grid.Row className="pb-0 pt-0">
                                <label className="w3-text-gray labelName text-nowrap">
                                  {t("list_view.driver_number") || "Driver Number"}
                                </label>
                              </Grid.Row>
                              : ""}

                          </Grid.Column>
                          <Grid.Column width={2}>
                            <Grid.Row className="pb-0 pt-0">
                              <label className="p-bold-600 text-nowrap ">
                                {item.vehicle_number}
                              </label>
                            </Grid.Row>
                            {item.driver_name ?
                              <Grid.Row className="pb-0 pt-0">
                                <label className="p-bold-600 text-nowrap ">
                                  {item.driver_name}
                                </label>
                              </Grid.Row>
                              : ""}
                            {item.driver_number ?
                              <Grid.Row className="pb-0 pt-0">
                                <label className="p-bold-600 text-nowrap">
                                  {item.driver_number}
                                </label>
                              </Grid.Row>
                              : ""}
                          </Grid.Column>
                          <Grid.Column width={3} textAlign="right" className="mt-2">
                            <div>
                              <span
                                className="sumo_truck_quantity"
                                style={{
                                  width: "55px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                              </span>
                              <img src="assets/svg/sumo_truck.svg" alt="sumo_truck" width="60%" />
                            </div>
                            <label className="w3-text-blue bfonter">
                              {t("list_view.movement_type") || "Movement Type"} : &nbsp;
                              <span className="p-bold-600 movement_type">{item.shipment.movement_type}</span>
                            </label>
                          </Grid.Column>
                        </Grid.Row>
                        {item.shipment.movement_type == "Import" || item.shipment.movement_type == "Importar" ?
                          <Grid.Row className="mr-0 ml-0 p-2 footer-text">
                            <span className="ml-3"> {t("list_view.bl_no") || "BL No."} :  </span>  <span className="ml-2"> <span>{item.bl_numbers != "" ? item.bl_numbers : "NA"}</span> </span>
                          </Grid.Row>
                          : ""}
                      </Grid>
                    </Link>
                  </Segment>
                </>
              );
            })
          ) :
            this.state.listItems.length == 0 && this.state.isFetching == false ? (
              <div>No Record(s) Found</div>
            ) : (
              <LoadingPlaceholder />
            )

          }
        </div>

        <div className="life-cycle w3-white p-2 mt-9">
          <Pagination
            defaultActivePage={this.props.pageNoLast || this.state.currentPage}
            firstItem={null}
            lastItem={null}
            onPageChange={this.handlePaginationChange}
            pointing
            secondary
            totalPages={this.state.totalPages}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate("shipment")(ReportingGridView);
